import Button from "@material-ui/core/Button";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  vButton: {
    padding: "0 4px",
    textTransform: "none",
    backgroundColor: "#464775",
    color: "#fff",
    minWidth: "55px",
    minHeight: "29px",
    boxShadow: "none",
    "&:hover": { backgroundColor: "#01998C", boxShadow: "none" },
  },
  xButton: {
    padding: "0 4px",
    backgroundColor: "#D9D9D9",
    color: "#6c6c6c",
    minWidth: "16.98px",
    minHeight: "29px",
    marginLeft: "7px",
    boxShadow: "none",
    "&:hover": { backgroundColor: "#C7C7C7", boxShadow: "none" },
  },
}));

export default ({ onConfirm, onReject }) => {
  const classes = useStyles();

  return (
    <div>
      <Button
        className={classes.vButton}
        size="small"
        variant="contained"
        onClick={onConfirm}
      >
        <DoneIcon />
      </Button>
      <Button
        className={classes.xButton}
        size="small"
        variant="contained"
        onClick={onReject}
      >
        <ClearIcon />
      </Button>
    </div>
  );
};
